if (!customElements.get('op-radio-selector-bridge')) {
    class OpRadioSelectorBridge extends HTMLElement {

        connectedCallback() {
            this.section = this.closest(this.dataset.sectionId);
            this.variantUrl = this.dataset.variantUrl;
            this.btn = this.section.querySelector('.js-variant-btn');
            // this.btn.href = this.variantUrl;
            this.radio = this.querySelector('input[type="radio"]');
            this.preselected = this.dataset.preselected === 'true';
            // this.productId = this.dataset.productId;
            this.radio.addEventListener('change', this.changeHandler);
            this.btn.addEventListener("click", () => {
                this.btn.closest("dialog").close();
            });
        }

        changeHandler = () => {
            if (this.radio.checked) {
                this.btn.href = this.variantUrl;
            };

        }
    }

    customElements.define("op-radio-selector-bridge", OpRadioSelectorBridge);
}